import { fromJS, List, Map } from 'immutable';

import {
  GET_SINISTRES,
  GET_SINISTRES_FAILED,
  GET_SINISTRE_DETAILS,
  GET_SINISTRE_DETAILS_FAILED,
  SET_SINISTRES,
  SET_SINISTRE_DETAILS,
  SET_REFUNDS_AMC,
  GET_REFUNDS_AMC,
  GET_REFUNDS_AMC_FAILED,
  SET_REFUND_AMC_DETAILS,
  GET_REFUND_AMC_DETAILS,
  GET_REFUND_AMC_DETAILS_FAILED,
} from 'store/sinistre/constants';
import { SinistreActionType } from 'store/sinistre/types';

export const initialState = fromJS({
  sinistres: [],
  sinistreDetails: [],
  hasError: null,
  isLoading: false,
  refundsAMC: {},
  isRefundsLoading: false,
  isRefundDetailLoading: false,
  errorMessageGetRefundsAMC: null,
  refundDetail: {},
  errorMessageGetRefundDetails: null,
});

export default function reducer(
  state = initialState,
  action: SinistreActionType,
) {
  switch (action.type) {
    case GET_SINISTRES:
      return state.set('isLoading', true).set('hasError', null);
    case SET_SINISTRES:
      return state
        .set('sinistres', List(action.payload))
        .set('isLoading', false);
    case GET_SINISTRES_FAILED:
      return state.set('isLoading', false).set('hasError', true);
    case GET_SINISTRE_DETAILS:
      return state.set('isLoading', true).set('hasError', null);
    case SET_SINISTRE_DETAILS:
      return state
        .set('sinistreDetails', List(action.payload))
        .set('isLoading', false);
    case GET_SINISTRE_DETAILS_FAILED:
      return state.set('isLoading', false).set('hasError', true);
    case GET_REFUNDS_AMC:
      return state.set('isRefundsLoading', true);
    case SET_REFUNDS_AMC:
      return state
        .set('refundsAMC', Map(action.payload))
        .set('isRefundsLoading', false);
    case GET_REFUNDS_AMC_FAILED:
      return state
        .set('isRefundsLoading', false)
        .set('errorMessageGetRefundsAMC', action.payload);
    case GET_REFUND_AMC_DETAILS:
      return state.set('isRefundDetailLoading', true);
    case SET_REFUND_AMC_DETAILS:
      return state
        .set('refundDetail', action.payload.data)
        .set('isRefundDetailLoading', false);
    case GET_REFUND_AMC_DETAILS_FAILED:
      return state
        .set('isRefundDetailLoading', false)
        .set('errorMessageGetRefundDetails', action.payload);
    default:
      return state;
  }
}
